// extracted by css-extract-rspack-plugin
module.exports =  {"contentBlock":"SubmitJobDialog__contentBlock___YN0jt"};